
import ogPagesMixins from '@/mixins/ogPagesMixins'
export default {
  mixins: [ogPagesMixins],
  props: {
    stream: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      posts: [],
      postsLimit: 3,
      postsOffset: 0,
      postsCount: 0,
    }
  },
  async fetch() {
    await this.fetchPosts()
  },
  computed: {
    seoTitle() {
      return `${this.stream?.stream?.title} : обзор журнала | Мегасреда`
    },
    seoDescription() {
      return this.stream?.stream?.description
    },
    seoH1() {
      return `Обзор журнала ${this.stream?.stream?.title}`
    },
    seoImage() {
      return {
        url: `https://api.megasreda.ru/image/ogimage/stream/${this.stream?.stream?.id}.jpg`,
        urlVk: `https://api.megasreda.ru/image/ogimage/stream/vk/${this.stream?.stream?.id}.jpg`,
        urlTw: `https://api.megasreda.ru/image/ogimage/stream/${this.stream?.stream?.id}.jpg`,
        type: 'image/jpeg',
        width: 1200,
        height: 630,
      }
    },
  },
  methods: {
    isVideo(article) {
      return article.type === 'video'
    },
    loadMore() {
      this.postsOffset = this.postsOffset + this.postsLimit
      this.fetchPosts()
    },

    updatePost() {
      this.posts = []
      this.fetchPosts()
    },

    async fetchPosts() {
      const { articles, countAllPublishedArticles } = await this.$axios.$get(
        `/review/stream/${this.$route.params.url}`,
        {
          params: {
            limit: this.postsLimit,
            offset: this.postsOffset,
          },
        }
      )

      this.postsCount = countAllPublishedArticles
      if (this.posts?.length) {
        this.posts = this.posts.concat(articles)
      } else {
        this.posts = articles
      }
    },
  },
}
